import { createSlice } from '@reduxjs/toolkit';

export interface ProjectBasicInfo {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  projectType: string;
  constructionType: string;
  budgetAcquisition: number;
  budgetConstruction: number;
  budgetSoft: number;
  budgetFinance: number;
  budgetDevelopment: number;
  projectBudget: number;
  squareFeet: number;
}

const initialState: ProjectBasicInfo = {
  name: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  projectType: '',
  constructionType: '',
  budgetAcquisition: 0,
  budgetConstruction: 0,
  budgetSoft: 0,
  budgetFinance: 0,
  budgetDevelopment: 0,
  projectBudget: 0,
  squareFeet: 0,
};

export const ProjectBasicInfoSlice = createSlice({
  name: 'projectBasicInfo',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    addBudget(state, { payload }) {
      return {
        ...state,
        projectBudget: state.projectBudget + payload,
      };
    },
  },
});

export const { set } = ProjectBasicInfoSlice.actions;

export default ProjectBasicInfoSlice.reducer;
